import { ButtonHTMLAttributes, ReactElement, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Button } from 'components';
import { ENV, localEnv, printId } from 'commons';
import * as S from './styles';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  onClick?: () => void;
  Template: ReactElement;
  devMode?: boolean;
  linkTemplate?: boolean;
}

export function Print({
  onClick,
  Template,
  devMode = false,
  linkTemplate = false,
  children,
  ...rest
}: Props) {
  function removePrintable() {
    const elPrintable = document.getElementById(printId);

    if (elPrintable) elPrintable.remove();
  }

  useEffect(() => {
    return () => removePrintable();
  });

  async function handlePrint() {
    if (onClick) onClick();

    removePrintable();

    const printableElement = document.createElement('div');
    printableElement.id = printId;

    const printableRoot = createRoot(printableElement);
    printableRoot.render(<S.Main>{Template}</S.Main>);

    await document.body.appendChild(printableElement);

    window.print();
  }

  if (ENV === localEnv && devMode) return <S.DevMode>{Template}</S.DevMode>;

  if (linkTemplate) return <S.Link onClick={handlePrint}>{children}</S.Link>;

  return (
    <Button {...rest} onClick={handlePrint} full>
      {children}
    </Button>
  );
}
